class AlpineStore {
  constructor(el, opt) {
    this.el = el;
    this.event();
  }
  event() {
    // スマホ判別
    Alpine.store('isMobile', window.innerWidth <= 768);

    function checkScreenSize() {
      Alpine.store('isMobile', window.innerWidth <= 768);
    }

    window.addEventListener('resize', checkScreenSize);

    // メガメニュー開閉用
    Alpine.store('megaMenu', false);
    // スマホメニュー開閉用
    Alpine.store('spMenu', false);
  }
}
